import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { UiVisualCustomization, UiVisualCustomizationResource } from '../resources/ui-visual-customization.resource';
import { DeepPartial } from '../utils/types';
import { UserNameService } from './user-name.service';

const BROADCAST_CHANNEL_NAME = 'uiVisualCustomization';

@Injectable({
  providedIn: 'root',
})
export class UiVisualCustomizationService {
  // UserName is used to find out if we logged in to application
  private userName: string | null;

  private uiVisualCustomizationSubject: ReplaySubject<DeepPartial<UiVisualCustomization> | null>;

  readonly uiVisualCustomization$: Observable<DeepPartial<UiVisualCustomization> | null>;

  private uiVisualCustomizationBroadcastChannel: BroadcastChannel;

  constructor(
    private uiVisualCustomizationResource: UiVisualCustomizationResource,
    private userNameService: UserNameService,
  ) {
    this.uiVisualCustomizationSubject = new ReplaySubject<DeepPartial<UiVisualCustomization> | null>(1);
    this.uiVisualCustomization$ = this.uiVisualCustomizationSubject.asObservable();
    this.userName = null;

    this.uiVisualCustomizationBroadcastChannel = new BroadcastChannel(BROADCAST_CHANNEL_NAME);
    this.uiVisualCustomizationBroadcastChannel.addEventListener(
      'message',
      (message) => this.updateUiVisualCustomization(message.data, true),
    );

    this.userNameService.userName$.subscribe((userName) => {
      this.userName = userName;
      this.reloadUiVisualCustomization();
    });
  }

  updateUiVisualCustomization(config: DeepPartial<UiVisualCustomization>, skipBroadcast?: boolean): void {
    this.uiVisualCustomizationSubject.next(config);
    if (!skipBroadcast) {
      this.uiVisualCustomizationBroadcastChannel.postMessage(config);
    }
  }

  reloadUiVisualCustomization() {
    if (this.userName != null) {
      this.uiVisualCustomizationResource.get().subscribe(
        (uiVisualCustomization) => {
          console.log('Loading UiVisualCustomization from server was successful');
          this.updateUiVisualCustomization(uiVisualCustomization);
        },
        (error) => {
          console.error('Failed to load UiVisualCustomization from server', error);
          this.uiVisualCustomizationSubject.next(null);
        },
      );
    } else {
      console.warn('UserName is missing, skipping loading UserInfo');
      this.uiVisualCustomizationSubject.next(null);
    }
  }
}
